<template>
  <div>

    <HeaderBreadcrumbs
      :items="[
        { label: 'Category BISAC' },
      ]"
      title="All Category BISAC"
    />

    <div class="bg-white w-full rounded-lg my-0 px-0 py-0">
      <b-row v-if="isError" class="justify-content-center mt-2">
          <b-col lg="10">
            <b-alert variant="danger" show dismissible>
              Opps .. Something is wrong
            </b-alert>
          </b-col>
        </b-row>
      <div class="flex justify-between py-3 mb-0 px-4">
        <div class="flex-col w-1/2 relative">
           <svg  class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
      <input
        type="text"
         class="px-11 py-2.5 border rounded-lg text-sm w-96 h-10"
        v-model="searchInput"
        placeholder="Search Category BISAC Name..."
        @input="debounceSearch"
      />
      <span class="mt-3 absolute left-0 top-8" v-if="typing">
        <em>Mencari ..</em>
      </span>
      <button
      v-if="searchInput"
    class="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
    @click="onRefresh"
    title="Clear search"
  >
    ✕
  </button>
    </div>
    <div class="flex justify-end">
      <button class="bg-blue-700 px-3 rounded-lg mr-4 h-10">
        <router-link :to="{ path: '/category-bisac/create' }" class="text-white">
          <i class="fa fa-plus"></i> Add New
        </router-link>
      </button>
      <t-dropdown>
        <div
          slot="trigger"
          slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
          class="flex"
        >
          <button
            class="flex items-center justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
            @mousedown="mousedownHandler"
            @focus="focusHandler"
            @blur="blurHandler"
            @keydown="keydownHandler"
          >
            <svg
              class="w-4 h-4 mr-1 text-gray-600 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
            </svg>
            Filter
            <svg
              class="w-5 h-5 ml-1 text-gray-600 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon
                points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
              />
            </svg>
          </button>
        </div>
        <div class="w-96 bg-white absolute -right-2 py-4 border rounded-lg" slot-scope="{ hide, blurHandler }">
          <div class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100" role="menuitem">
             <label class="text-gray-600 font-semibold mb-3">Status</label>
            <StatusFilterComponent
                  class="mb-4"
                  v-model="status"
                  :options="statusOptions"
                  :defaultText="`Select Status`"
                />
            <div>
              <button class="border bg-blue-700 px-4 py-2 text-white rounded-lg" @click="onStatusChange" @blur="blurHandler">
                Filter
              </button>
              <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="onReset()" @blur="blurHandler">Reset</button>
            </div>
          </div>
        </div>
      </t-dropdown>
    </div>
  </div>
  <div ref="scrollContainer" class="relative">
    <t-table class="bg-white shadow-none" :headers="['No', 'Email', 'Sales', 'Actions']" :data="category_bisac">
      <template v-if="!category_bisac.length" v-slot:tbody="props">
        <tbody :class="props.tbodyClass">
          <tr :class="[props.trClass, 'text-center']">
            <td :class="props.tdClass" colspan="15">
              <div class="flex-col items-center justify-center flex-nowrap flex h-96">
                <svg width="35" height="35" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z"
                    fill="#4B5563" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z"
                    fill="#4B5563" />
                  <path
                    d="M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z"
                    fill="#4B5563" />
                </svg>
                <h4 class="text-base text-gray-600 mb-0">No results found</h4>
                <p class="text-sm text-gray-500">Change your keyword or filter</p>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
      <template v-slot:thead="props">
        <thead class="sticky-header">
          <tr>
            <th :class="props.thClass" class="text-center">No</th>
            <th :class="props.thClass">Category BISAC name</th>
            <th :class="props.thClass">CODE</th>
            <th :class="props.thClass">SLUG</th>
            <th :class="props.thClass">status</th>
            <th :class="props.thClass"></th>
          </tr>
        </thead>
      </template>
      <template v-slot:row="props">
        <tr>
          <td :class="props.tdClass" class="text-center">
            {{ (currentPage - 1) * perPage + props.rowIndex + 1 }}
          </td>
          <td :class="props.tdClass">
            <router-link :to="{ path: 'category-bisac/edit/' + props.row.id }" class="link text-gray-600">
              {{ props.row.name }}
            </router-link>
          </td>
          <td :class="props.tdClass" class="text-gray-600">
            {{ props.row.code  }}
          </td>
          <td :class="props.tdClass">
            {{ props.row.slug ? props.row.slug : '-' }}
          </td>

          <td :class="props.tdClass">
            <span v-if="props.row.is_active" class="bg-blue-100 text-blue-700 px-2 py-1 font-semibold rounded-lg">
                Active
              </span>
              <span v-else class="bg-red-100 text-red-700 px-2 py-1 font-semibold rounded-lg">Inactive</span>
          </td>

          <td :class="props.tdClass">
            <router-link :to="{ path: 'category-bisac/edit/' + props.row.id }" class="link text-gray-600">
              <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z" clip-rule="evenodd"/>
            <path fill-rule="evenodd" d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z" clip-rule="evenodd"/>
          </svg>

            </router-link>

          </td>
        </tr>
      </template>
    </t-table>
  </div>
  <div v-if="!isLoading" class="flex bg-white justify-between pl-0 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
            @change="onClickPage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import StatusFilterComponent from '../../components/form/StatusFilterComponent.vue';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';

export default {
  name: 'CategoryBisac',
  components: {
    StatusFilterComponent,
    HeaderBreadcrumbs,
  },
  data() {
    return {
      message: '',
      typing: null,
      currentPage: 1,
      perPage: 20,
      searchInput:"",
      debounce: null,
      fields: [
        { key: 'No', label: 'No.', thStyle: { maxWidth: '15px' } },
        {
          key: 'name',
          label: 'Name',
        },
        { key: 'code', label: 'Code' },
        { key: 'slug', label: 'Slug' },
        { key: 'is_active', label: 'Status' },
      ],
      status: null,
      statusOptions: [
        { value: null, text: 'All Status' },
        { value: 1, text: 'Active' },
        { value: 2, text: 'Inactive' },
      ],
    };
  },
  watch: {
    currentPage: function() {
      this.getCategoryBisac();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Category Bisac | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.category_bisac.isLoading,
      isError: (state) => state.category_bisac.isError,
      totalRows: (state) => state.category_bisac.totalRows,
      category_bisac: (state) => state.category_bisac.items,
    }),
  },
  mounted() {
    this.getCategoryBisac();
  },
  methods: {
    ...mapActions('category_bisac', [
      'fetchCategoryBisac',
      'findCategoryBisac',
      'fetchCategoryBisacById',
    ]),

    getCategoryBisac() {
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
        is_active: this.status,
      };
      if (!this.message) {
        payload.name = '';
      }
      this.fetchCategoryBisac(payload);
    },

    debounceSearch(event) {
      this.typing = 'You are typing';
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = null;
        this.message = event.target.value;
        let payload = {
          page: this.currentPage,
          limit: this.perPage,
          is_active: this.status,
        };
        if (this.message) {
          payload.name = this.message;
        }
        this.fetchCategoryBisac(payload);
      }, 600);
    },
    onRefresh() {
      this.getCategoryBisac()
      this.searchInput = ""
      this.message = ""
    },
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    onClickPage(page) {
      this.currentPage = page;
    },
    onStatusChange() {
      let payload = {
        is_active: this.status,
        page: this.currentPage,
        limit: this.perPage,
      };
      if (this.message) {
        payload.name = this.message;
      }
      this.fetchCategoryBisac(payload);
    },
    onReset() {
      let payload = {
        is_active:  this.status = null,
        page: this.currentPage,
        limit: this.perPage,
      };
      if (this.message) payload.name = this.message;
      this.fetchCategoryBisac(payload);
    },
  },
};
</script>
<style scoped>
.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  transition: all 0.3s;
}
</style>
